module.exports = __webpack_public_path__ + "img/Weapon_235.87ba3cd0.png";